/**
 * SuiteCRM is a customer relationship management program developed by SalesAgility Ltd.
 * Copyright (C) 2021 SalesAgility Ltd.
 *
 * This program is free software; you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License version 3 as published by the
 * Free Software Foundation with the addition of the following permission added
 * to Section 15 as permitted in Section 7(a): FOR ANY PART OF THE COVERED WORK
 * IN WHICH THE COPYRIGHT IS OWNED BY SALESAGILITY, SALESAGILITY DISCLAIMS THE
 * WARRANTY OF NON INFRINGEMENT OF THIRD PARTY RIGHTS.
 *
 * This program is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
 * FOR A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 *
 * In accordance with Section 7(b) of the GNU Affero General Public License
 * version 3, these Appropriate Legal Notices must retain the display of the
 * "Supercharged by SuiteCRM" logo. If the display of the logos is not reasonably
 * feasible for technical reasons, the Appropriate Legal Notices must display
 * the words "Supercharged by SuiteCRM".
 */

import {Injectable} from '@angular/core';
import {combineLatestWith, Observable} from 'rxjs';
import {ScreenSize, ScreenSizeObserverService} from '../screen-size-observer/screen-size-observer.service';
import {distinctUntilChanged, map} from 'rxjs/operators';
import {SystemConfigStore} from '../../../store/system-config/system-config.store';

@Injectable()
export class MaxColumnsCalculator {

    screen: ScreenSize = ScreenSize.Medium;
    maxColumns = 5;

    constructor(
        protected screenSize: ScreenSizeObserverService,
        protected systemConfigStore: SystemConfigStore
    ) {
    }

    getMaxColumns(sidebarActive$: Observable<boolean>): Observable<number> {
        return sidebarActive$.pipe(
            combineLatestWith(this.screenSize.screenSize$),
            map(([sidebarActive, screenSize]: [boolean, ScreenSize]) => {

                if (screenSize) {
                    this.screen = screenSize;
                }

                return this.calculateMaxColumns(sidebarActive);
            }),
            distinctUntilChanged()
        );
    }

    calculateMaxColumns(sideBar = true): number {
        let sizeMap;
        sizeMap = this.systemConfigStore.getConfigValue('listview_column_limits');

        if (sideBar) {
            sizeMap = sizeMap.with_sidebar;
        } else {
            sizeMap = sizeMap.without_sidebar;
        }

        if (this.screen && sizeMap) {
            const maxCols = sizeMap[this.screen];
            if (maxCols) {
                this.maxColumns = maxCols;
            }
        }

        return this.maxColumns;
    }
}
